import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // hash(#about 등)로 이동하는 경우는 브라우저가 처리하도록 스킵
    if (hash) return;

    // 라우트 이동 시 맨 위로
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    const contentContainer = document.querySelector('.page-content');
    if (contentContainer) {
      contentContainer.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth" // 페이지 전환 시 즉시 이동하려면 auto, 부드럽게는 smooth
      });
    }
  }, [pathname, hash]);

  return null;
}